/* esm.sh - @radix-ui/react-use-controllable-state@1.2.2 */
export * from "/*@radix-ui/react-use-controllable-state@1.2.2/esnext/react-use-controllable-state.mjs";
